module.exports = __webpack_public_path__ + "static/media/cardshuffle.07bf19f7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/cardshuffle.mp3
// module id = 508
// module chunks = 0